/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CheckPhoneAvailabilityDto } from '../models/CheckPhoneAvailabilityDto';
import type { CreateHandoverTicketDto } from '../models/CreateHandoverTicketDto';
import type { HandoverTicketResponseDto } from '../models/HandoverTicketResponseDto';
import type { OnboardingProfileResponseDto } from '../models/OnboardingProfileResponseDto';
import type { OnboardingProgressResponseDto } from '../models/OnboardingProgressResponseDto';
import type { PhoneAvailabilityResponseDto } from '../models/PhoneAvailabilityResponseDto';
import type { SelectRoleDto } from '../models/SelectRoleDto';
import type { SendOtpResponseDto } from '../models/SendOtpResponseDto';
import type { SendPhoneOtpDto } from '../models/SendPhoneOtpDto';
import type { UpdateOnboardingProfileDto } from '../models/UpdateOnboardingProfileDto';
import type { VerifyPhoneOtpDto } from '../models/VerifyPhoneOtpDto';
import type { VerifyPhoneOtpResponseDto } from '../models/VerifyPhoneOtpResponseDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class OnboardingService {
    /**
     * Select or change user role
     * Sets the user role to client or expert. This is the first step of onboarding. If the role changes, new JWT tokens are generated and returned in the response (and set as httpOnly cookies for web clients). The frontend should replace its stored tokens.
     * @param requestBody
     * @returns any Role updated successfully
     * @throws ApiError
     */
    public static onboardingControllerSelectRoleV1(
        requestBody: SelectRoleDto,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/v1/onboarding/role',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation failed`,
                401: `Unauthorized`,
                404: `User not found`,
            },
        });
    }
    /**
     * Save onboarding profile data
     * Saves onboarding fields for both clients and experts. Partial updates only — only provided fields are updated. Supports role selection, basic info, client preferences, expert service areas, services, and document metadata. Call multiple times as the user progresses through onboarding screens.
     * @param requestBody
     * @returns OnboardingProfileResponseDto Profile updated successfully
     * @throws ApiError
     */
    public static onboardingControllerUpdateProfileV1(
        requestBody: UpdateOnboardingProfileDto,
    ): CancelablePromise<OnboardingProfileResponseDto> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/v1/onboarding/profile',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation failed`,
                401: `Unauthorized`,
                404: `User not found`,
                409: `Email or phone number already in use`,
            },
        });
    }
    /**
     * Check whether a phone number is free
     * Answers whether the caller can claim this number, without sending an SMS. Used before role selection so a social signup whose number already belongs to another account finds out immediately instead of at the end of onboarding. A number owned by someone else returns 409 with errorCode PHONE_OWNED_BY_ANOTHER_ACCOUNT; the caller should offer the handover flow.
     * @param requestBody
     * @returns PhoneAvailabilityResponseDto Phone number is available
     * @throws ApiError
     */
    public static onboardingControllerCheckPhoneAvailabilityV1(
        requestBody: CheckPhoneAvailabilityDto,
    ): CancelablePromise<PhoneAvailabilityResponseDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/onboarding/phone/availability',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation failed`,
                401: `Unauthorized`,
                409: `Phone number belongs to another account (PHONE_OWNED_BY_ANOTHER_ACCOUNT)`,
                429: `Too many availability checks`,
            },
        });
    }
    /**
     * Mint a handover ticket for a duplicate signup
     * Issues a single-use token that moves this account's Google/Apple identity to the account that already owns the given phone number. Writes nothing — the move happens at POST /v1/auth/reattach, after the user has signed in to that account by OTP. Only callable by a social signup that has not yet selected a role.
     * @param requestBody
     * @returns HandoverTicketResponseDto Handover ticket created
     * @throws ApiError
     */
    public static onboardingControllerCreateHandoverTicketV1(
        requestBody: CreateHandoverTicketDto,
    ): CancelablePromise<HandoverTicketResponseDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/onboarding/handover-ticket',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Number is not registered to another account`,
                401: `Unauthorized`,
                403: `Account is not eligible for handover`,
                404: `User not found`,
                429: `Too many handover requests`,
            },
        });
    }
    /**
     * Send phone verification OTP
     * Sends an OTP to the provided phone number for verification during onboarding. Only applicable for users who signed up via Google or Apple (they need to add and verify a phone). Users who registered via phone already have a verified number — this endpoint will return 400.
     * @param requestBody
     * @returns SendOtpResponseDto OTP sent successfully
     * @throws ApiError
     */
    public static onboardingControllerSendPhoneOtpV1(
        requestBody: SendPhoneOtpDto,
    ): CancelablePromise<SendOtpResponseDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/onboarding/phone/send-otp',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Phone already verified via registration`,
                401: `Unauthorized`,
                404: `User not found`,
                409: `Phone number belongs to another account (PHONE_OWNED_BY_ANOTHER_ACCOUNT), or to a deleted account (no errorCode — not actionable by the client)`,
                429: `Too many OTP requests`,
            },
        });
    }
    /**
     * Verify phone OTP
     * Verifies the OTP code sent to the user's phone during onboarding. On success, the phone number is saved to the user record. Max 5 failed attempts allowed before a 5-minute lockout is enforced. User can retry with correct OTP after cooldown.
     * @param requestBody
     * @returns VerifyPhoneOtpResponseDto Phone number verified successfully
     * @throws ApiError
     */
    public static onboardingControllerVerifyPhoneOtpV1(
        requestBody: VerifyPhoneOtpDto,
    ): CancelablePromise<VerifyPhoneOtpResponseDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/onboarding/phone/verify-otp',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Invalid OTP code`,
                401: `Unauthorized`,
                409: `The number was claimed by another account between send and verify (PHONE_OWNED_BY_ANOTHER_ACCOUNT)`,
                410: `OTP expired or session expired`,
                429: `Too many failed attempts — 5-minute lockout enforced, retry after cooldown`,
            },
        });
    }
    /**
     * Get onboarding progress
     * Returns the full user profile data (including role-specific data) along with a completion checklist. The checklist varies by role: clients need basic info + preferences, experts need basic info + service areas + services + documents. If all steps are complete, the user's onboarding flag is automatically set to true.
     * @returns OnboardingProgressResponseDto Onboarding progress retrieved
     * @throws ApiError
     */
    public static onboardingControllerGetProgressV1(): CancelablePromise<OnboardingProgressResponseDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/onboarding/progress',
            errors: {
                401: `Unauthorized`,
                404: `User not found`,
            },
        });
    }
    /**
     * Accept Terms of Service
     * Records the user's acceptance of the Terms of Service / Code of Conduct. This is a required step for completing onboarding for both clients and experts. Sets the tos_accepted_at timestamp on the user record.
     * @returns any Terms of Service accepted
     * @throws ApiError
     */
    public static onboardingControllerAcceptTosV1(): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/onboarding/accept-tos',
            errors: {
                401: `Unauthorized`,
                404: `User not found`,
            },
        });
    }
}
